import React from 'react';
import { TableHead, TableRow, TableCell, Checkbox } from '@mui/material';

interface TableHeaderProps {
  selectAll: boolean;
  checkAllParcel: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const TableHeader: React.FC<TableHeaderProps> = ({ selectAll, checkAllParcel }) => {
  return (
    <TableHead>
      <TableRow style={{ backgroundColor: '#F8F9F9' }}>
        <TableCell align="left">
          <Checkbox checked={selectAll ?? false} onChange={checkAllParcel} />
        </TableCell>
        <TableCell>
          <b>Date</b>
        </TableCell>
        <TableCell align="center">
          <b>IDs</b>
        </TableCell>
        <TableCell align="left">
          <b>Customer</b>
        </TableCell>
        <TableCell align="left">
          <b>Payment Info</b>
        </TableCell>
        <TableCell align="left">
          <b>Status</b>
        </TableCell>
        <TableCell align="left">
          <b>Action</b>
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default TableHeader;
